import React from 'react';
import {
    Container,
} from "react-bootstrap";
import getBrandName from "app/shared/utils/BrandHelper";

type Props = {
    title?: string,
    subText?: string,
};

const HeaderContents: React.FC<Props> = ({ title, subText }) => {
    const { rewardsLogoPath } = getBrandName();

    return (
        <Container className="d-flex align-items-center flex-column">
            <img
                className="sign-up-logo headerLogoImageMobile"
                src={rewardsLogoPath}
                alt="Brand logo"
            />
            {title
                && <h3 className="p-2 m-0 join-now-title">{title}</h3>}
            {subText
                && <p className="signOn-subText-Light text-center modalSubText mb-2">{subText}</p>}
        </Container>
    );
};
export default HeaderContents;
